import React, { Component } from 'react';
import { Box, FlexColumn } from 'core/components';
import Markdown from 'app/components/markdown/Markdown';
import styled from 'styled-components';
import SettingsPanelHeading from 'app/views/settings/ai/SettingsPanelHeading';

const StyleWrapper = styled.div`
  li {
    padding-bottom: 8px;
  }
`;

const Section = ({ title, children, ...rest }) => (
  <Box>
    <Box {...rest}>
      <SettingsPanelHeading level={2}>{title}</SettingsPanelHeading>
      <StyleWrapper>
        <Markdown>{children}</Markdown>
      </StyleWrapper>
    </Box>
  </Box>
);

const dataPrivacyLink = `
The privacy and security of your data is our highest priority. For a detailed explanation of how Kentik AI interacts with your data,
please see [this article in the Kentik Knowledge Base](https://kb.kentik.com/docs/kentik-ai-overview).
`;
class AIFaq extends Component {
  render() {
    return (
      <FlexColumn p={4}>
        <Section title="Privacy and Security">{dataPrivacyLink}</Section>
      </FlexColumn>
    );
  }
}

export default AIFaq;
